<template>
  <pipeline-layout-tab>
    <pipeline-layout-tab-main>
      <follow-up-comm-log class="record_content is-comms" :record="record"/>
    </pipeline-layout-tab-main>

    <pipeline-layout-tab-aside>
      <app-loading-section :loading="pageLoading"></app-loading-section>
      <follow-up-contact-box
        :contact="contact"
        :record="record"
        class="mb-100"
      ></follow-up-contact-box>

      <follow-up-lead-box
        :record="record"
        class="mb-100"
      ></follow-up-lead-box>
    </pipeline-layout-tab-aside>
  </pipeline-layout-tab>
</template>

<script>
import PipelineLayoutTab from "../../../components/PipelineLayoutTab";
import PipelineLayoutTabMain from "../../../components/PipelineLayoutTabMain";
import PipelineLayoutTabAside from "../../../components/PipelineLayoutTabAside";
import FollowUpCommLog from "./FollowUpCommLog";
import FollowUpContactBox from "./FollowUpContactBox";
import FollowUpLeadBox from "./FollowUpLeadBox";

export default {
  name: "FollowUpContent",
  components: {
    FollowUpLeadBox,
    FollowUpContactBox,
    FollowUpCommLog,
    PipelineLayoutTabAside,
    PipelineLayoutTabMain,
    PipelineLayoutTab
  },
  props: {
    contact: {
      type: Object,
    },
    record: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      pageLoading: false,
      propertyInfo: null,
      contactInfo: null,
    };
  },
  destroyed() {
    this.$store.dispatch("activeFollowUpStateItem/tearDown");
  },
  mounted() {
    // Get Communication Log for Contact
    if (this.contact) {
      this.pageLoading = true
      this.$store.dispatch("activeFollowUpStateItem/setup", this.record.id)
        .then(() => this.pageLoading = false);
    } else {
      this.pageLoading = false;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../../styles/variables/variables";

.record_content {
  height: 100%;
}
</style>
